import React, { useEffect, useState } from 'react';
import { generatePath, useLocation, useNavigate, useParams } from "react-router-dom";
import Firebase from "../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { Button, Card, Divider, Layout, Tabs } from "antd";
import { MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import { useListVals } from "../../Firebase/databaseHooks";
import EditSurvey from "../../Modals/Surveys/EditSurvey";
import SurveyQuestions from "./SurveyQuestions";
import AddQuestion from "../../Modals/Surveys/AddQuestion";
import SurveyResponses from "./SurveyResponses";


const { TabPane } = Tabs;
var db = getDatabase(Firebase);
const SurveyDetails = () => {

	const { id } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const [checkedData, setCheckedData] = useState(false);
	const [survey, setSurvey] = useState(location.state?.survey || null);
	const [addModal, setAddModal] = useState(false);
	const [questions] = useListVals(ref(db, `talmidsdb/surveys/${id}/questions`));

	useEffect(() => {
		if (location.state?.survey === undefined) {
			navigate("/surveys", { replace: true });
		} else {
			setSurvey(location.state.survey);
		}

	}, [id, location.state, questions, navigate])

	const callback = (data) => {
		setCheckedData(data);
	}

	const createForm = (id, object) => {
		navigate(generatePath("/surveys/form/:id", { id }), { state: { survey: object } });
	};
	if (!survey) {
		return null;
	}
	return (
		<>
			<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
				<MDBRow className="w-100">
					<MDBCol md={12}>
						<Card className="w-100">
							<MDBRow>
								<MDBCol md={12}>
									<div className="text-left">
										<div className="d-flex flex-row justify-content-between">
											<div className="d-inline">
												<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
													<Text family='Nunito'>
														{survey?.title || "Survey"}
													</Text>
												</h5>
											</div>
											<div className="d-flex justify-content-end my-1">
												<Button type="primary" onClick={() => {
													createForm(id, survey);
												}}>
													Get Link
												</Button>
											</div>
										</div>
									</div>
								</MDBCol>
							</MDBRow>
						</Card>
						<Card>
							<Tabs defaultActiveKey="1" type="card" size={"normal"}>
								<TabPane tab="Details" key="1">
									<div className="pr-5">
										<EditSurvey survey={survey} />
									</div>
								</TabPane>
								<TabPane tab="Questions" key="2">
									<AddQuestion surveyID={id} modal={addModal} setModal={setAddModal} />
									<div className="d-flex justify-content-end my-1">
										<Button type="primary" onClick={() => {
											setAddModal(true);
										}}>
											Add Question
										</Button>
									</div>
									<Divider />
									<div>
										<SurveyQuestions surveyID={id} />
									</div>
								</TabPane>
								<TabPane tab="Responses" key="3">
									<div>
										<SurveyResponses />
									</div>
								</TabPane>
							</Tabs>
						</Card>
					</MDBCol>
				</MDBRow>
			</div>
		</>
	)
}

export default SurveyDetails;
